import { ICreateThemeColorsParams } from '@aquariuxfintech/aqx-trader-sdk-config/theme';

const CUSTOM_GREEN = 'rgb(15,178,165)'; // #0FB2A5
const CUSTOM_RED = 'rgb(244,0,0)'; // #F40000

export const HANTEC_GENERIC_THEME_COLORS: ICreateThemeColorsParams = {
  error: CUSTOM_RED,
  success: CUSTOM_GREEN,
  pnl: {
    positive: {
      default: CUSTOM_GREEN,
      hover: 'rgb(13, 154, 143)',
      active: 'rgb(11, 131, 121)'
    },
    negative: {
      default: CUSTOM_RED,
      hover: 'rgb(219, 0, 0)',
      active: 'rgb(195, 0, 0)'
    }
  },
  tag: {
    success: {
      color: CUSTOM_GREEN
    },
    error: {
      color: CUSTOM_RED
    }
  },
  doughnut: [
    'rgba(15, 178, 165, 0.8)',
    'rgba(2, 208, 191, 0.8)',
    'rgba(107, 107, 99, 0.8)',
    'rgba(201, 201, 201, 0.8)',
    'rgba(29, 101, 75, 0.8)',
    'rgba(114, 147, 144, 0.8)'
  ]
};
